import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { ImageCropDialogProps } from ".";
import { ImageCropper } from "../ImageCropper";

const TrimmingModal: React.FC<ImageCropDialogProps> = ({
  title,
  uploadImage,
  onCancel,
  onConfirm,
  ...props
}) => {
  return (
    <Dialog fullScreen {...props}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <ImageCropper image={uploadImage} onConfirm={onConfirm} onCancel={onCancel} />
      </DialogContent>
      {/*
            <DialogActions>
        <Button onClick={onCancel} color="primary">
            Cancel
        </Button>
      </DialogActions>
       */}

    </Dialog>
  );
};

export default TrimmingModal;
